<div class="mb-2">
	<span *ngFor="let mdValue of item?.allMetadata(['dc.identifier.doi'])">
	<h5>Associated DOI</h5>
   		<a href="https://doi.org/{{mdValue.value}}" target="_blank">{{mdValue.value}}</a>
    <br>
    </span>
</div>